var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 1.5C13.1324 1.5 16.4999 4.86 16.4999 9C16.4999 13.1325 13.1324 16.5 8.99988 16.5C4.85988 16.5 1.49988 13.1325 1.49988 9C1.49988 4.86 4.85988 1.5 8.99988 1.5ZM6.79488 7.5225C6.57738 7.2975 6.21738 7.2975 5.99988 7.515C5.77488 7.74 5.77488 8.0925 5.99988 8.31L8.60238 10.9275C8.70738 11.0325 8.84988 11.0925 8.99988 11.0925C9.14988 11.0925 9.29238 11.0325 9.39738 10.9275L11.9999 8.31C12.1124 8.205 12.1649 8.0625 12.1649 7.92C12.1649 7.77 12.1124 7.6275 11.9999 7.515C11.7749 7.2975 11.4224 7.2975 11.2049 7.5225L8.99988 9.735L6.79488 7.5225Z",
    fill: "#FF0909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 9C13.4999 11.4853 11.4852 13.5 8.99988 13.5C6.5146 13.5 4.49988 11.4853 4.49988 9C4.49988 6.51472 6.5146 4.5 8.99988 4.5C11.4852 4.5 13.4999 6.51472 13.4999 9Z",
    fill: "#FF0909"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.625,
    y: 8.25,
    width: 7.125,
    height: 1.5,
    rx: 0.75,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.5656cf9b.svg";
export { ForwardRef as ReactComponent };